import { memo, useMemo } from "react";

import { Checkbox } from "@/components/ui/input/checkbox";

type Props = {
	title: string;

	/**
	 * 所要時間
	 */
	requiredTime?: number;

	/**
	 * チェックボックスの表示有無
	 */
	showCheckBox: boolean;

	/**
	 * チェックボックスの状態
	 */
	checkBoxStatus: boolean;

	/**
	 * 補足情報
	 */
	supplementaryInfo?: React.ReactNode;
};

export const TodoListSectionItemLinkContent = memo(
	({ title, showCheckBox = true, checkBoxStatus, supplementaryInfo, requiredTime }: Props) => {
		const isShowRequiredTime = useMemo(
			() => requiredTime && Number.isSafeInteger(requiredTime) && requiredTime > 0,
			[requiredTime],
		);

		return (
			<div className="space-y-1">
				<div className="flex items-center gap-x-4">
					{showCheckBox && <Checkbox className="h-[18px] w-[18px] cursor-default" checked={checkBoxStatus} />}

					<div className="flex flex-1 flex-wrap items-center justify-between">
						<p className="mb-0.5 text-base tracking-wide">{title}</p>

						{isShowRequiredTime && (
							<div className="flex justify-end">
								<p className="text-sm text-zinc-500">（所要時間：{requiredTime}分〜）</p>
							</div>
						)}
					</div>
				</div>

				{Boolean(supplementaryInfo) && <div className="text-xs text-zinc-500">{supplementaryInfo}</div>}
			</div>
		);
	},
);

TodoListSectionItemLinkContent.displayName = "TodoListSectionItemLinkContent";
